import loadImage from 'blueimp-load-image';

import { logger } from './logger';

/**
 * Normalize image orientation based on EXIF (handles iOS rotation issues).
 * Returns the corrected File or the original if correction fails.
 */
export async function fixImageOrientation(file: File): Promise<File> {
  return new Promise((resolve) => {
    loadImage(
      file,
      (eventOrImage: HTMLImageElement | HTMLCanvasElement | Event) => {
        // Error case
        if (eventOrImage instanceof Event) {
          logger.error('[fixImageOrientation] Error loading image:', eventOrImage);
          resolve(file);
          return;
        }

        // Success case: canvas with corrected orientation
        if (eventOrImage instanceof HTMLCanvasElement) {
          eventOrImage.toBlob((blob) => {
            if (blob) {
              const correctedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified,
              });
              resolve(correctedFile);
            } else {
              logger.error('[fixImageOrientation] Failed to create blob from canvas');
              resolve(file);
            }
          }, file.type);
        } else {
          // Unexpected type (HTMLImageElement) – fall back to original file
          logger.error('[fixImageOrientation] Expected canvas but got image element');
          resolve(file);
        }
      },
      {
        orientation: true, // Automatically apply EXIF orientation
        canvas: true,      // Return a canvas element
        maxWidth: 4096,
        maxHeight: 4096,
      }
    );
  });
}

